<footer class="bg-white border-t border-gray-200 mt-auto">
	<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
		<div class="grid grid-cols-1 md:grid-cols-3 gap-8">
			<!-- About -->
			<div>
				<h3 class="text-lg font-semibold mb-4">Svelte Perfect Select</h3>
				<p class="text-gray-600 text-sm">
					A modern, feature-rich select component for Svelte with react-select compatibility and
					beautiful themes.
				</p>
			</div>

			<!-- Links -->
			<div>
				<h3 class="text-lg font-semibold mb-4">Quick Links</h3>
				<ul class="space-y-2">
					<li>
						<a href="/playground" class="text-gray-600 hover:text-blue-600 text-sm">Playground</a>
					</li>
					<li>
						<a href="/docs" class="text-gray-600 hover:text-blue-600 text-sm">Documentation</a>
					</li>
				</ul>
			</div>

			<!-- Resources -->
			<div>
				<h3 class="text-lg font-semibold mb-4">Resources</h3>
				<ul class="space-y-2">
					<li>
						<a
							href="https://github.com/ishansasika/svelte-perfect-select"
							target="_blank"
							rel="noopener noreferrer"
							class="text-gray-600 hover:text-blue-600 text-sm"
						>
							GitHub
						</a>
					</li>
					<li>
						<a
							href="https://www.npmjs.com/package/svelte-perfect-select"
							target="_blank"
							rel="noopener noreferrer"
							class="text-gray-600 hover:text-blue-600 text-sm"
						>
							NPM Package
						</a>
					</li>
				</ul>
			</div>
		</div>

		<div class="mt-8 pt-8 border-t border-gray-200 text-center text-gray-600 text-sm">
			<p>&copy; {new Date().getFullYear()} Svelte Perfect Select. Built by Ishan Karunaratne.</p>
		</div>
	</div>
</footer>
